module.exports = __webpack_public_path__ + "media/images/firsttime_contents03_sp-119cc4770e2e1bec70052c7c5cace244.png";